import React, { CSSProperties, ReactElement, useEffect, useRef } from "react";
import styled from "styled-components";
import { useOnClickOutside } from "../../hooks/useClickOutside";
import { WindowSizePXEnum } from "../../interface/Basic/window";
import { Close, GoBack } from "../../icon/Icon";
import { IconContainerPointer } from "../../components/ui/Content";
import { Title } from "../../components/Font";
import { LoaderContainer } from "../Loader/MiniLoader";

interface IPopupProps {
  opened: boolean;
  title?: string | ReactElement;
  children: ReactElement | ReactElement[];
  style?: CSSProperties;
  styleHeader?: CSSProperties;
  onClose?(): void;

  onGoBack?(): void;
  className?: HTMLDivElement["className"];
}

export const Popup = ({
  onClose,
  title,
  opened,
  children,
  style,
  styleHeader,
  onGoBack,
  className,
}: IPopupProps) => {
  const ref = useRef(null);

  useOnClickOutside(ref, () => onClose?.());

  useEffect(() => {
    const scrolledUnderPopup = document.querySelector(".box-isolated");
    if (opened) {
      // i hate safari
      scrolledUnderPopup?.classList.add("no-scroll");
    } else {
      scrolledUnderPopup?.classList.remove("no-scroll");
    }
    return () => {
      scrolledUnderPopup?.classList.remove("no-scroll");
    };
  }, [opened]);

  if (!opened) {
    return null;
  }

  return (
    <PopupOverlay ref={ref}>
      <PopupContainer className={className} style={style}>
        <PopupHeader style={styleHeader}>
          {onGoBack ? (
            <IconContainerPointer onClick={onGoBack}>
              <GoBack />
            </IconContainerPointer>
          ) : (
            <div style={{ width: 16 }} />
          )}
          {title && <Title>{title}</Title>}
          {onClose ? (
            <IconContainerPointer onClick={onClose}>
              <Close />
            </IconContainerPointer>
          ) : (
            <div style={{ width: 16 }} />
          )}
        </PopupHeader>
        <PopupBody>{children}</PopupBody>
      </PopupContainer>
    </PopupOverlay>
  );
};

const PopupOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1234567;

  .radius {
    border-radius: 12px;
    @media (max-width: ${WindowSizePXEnum.xs}) {
      border-radius: 0;
    }
  }
`;
export const PopupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  ${IconContainerPointer} {
    path {
      fill: #c4c7cb;
    }
  }

  ${Title} {
    margin: 0;
    max-width: 380px;
    text-align: center;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    padding: 24px 16px;

    font-size: 20px;
    line-height: 24px;
  }
  @media (max-width: ${WindowSizePXEnum.xxs}) {
    ${Title} {
      font-size: 20px;
      line-height: 24px;
    }
  }
`;
const PopupBody = styled.div`
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  position: relative;
  ${LoaderContainer} {
    z-index: 2;
    position: absolute;
    inset: 0;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
`;
const PopupContainer = styled.div`
  display: flex;
  padding: 0 40px 20px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.25);
  width: 60%;
  height: 60%;

  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100% !important;
    height: 100% !important;
  }
`;
